export const ALLOWED_AGREEMENT_STATUS = [
    'active',
    'amended',
    'exhausted',
    'terminated'
];
export const ALLOWED_PAYMENT_METHOD = [
    'bank',
    'credit',
    'notSet',
    'verificationInitiated',
    'verificationFailed'
];
export const ALLOWED_HAS_CREDIT = [
    'yes',
    'no'
];
export const ALLOWED_AMENDMENT_STATUS = [
    'amendmentDraft',
    'awaitingApproval',
    'noChanges'
];
export const ALLOWED_AGREEMENT_BILLED_UPON = [
    'ongoing',
    'oneTimeManual',
    'approval',
    'repeatableManual',
    'oneTimeDelivery',
    'oneTimeInStages',
    'onDemand',
    'inStagesManual',
    'inStagesPartlyAutomatic',
    'inStagesAutomatic'
];
export const ALLOWED_AGREEMENT_RECURRENCE = [
    'weekly',
    'biweekly',
    'monthly',
    'quarterly',
    'yearly',
    'oneTime',
    'onDemand'
];
export const ALLOWED_AGREEMENT_PRICING_TYPE = [
    'fixed',
    'variable',
    'range',
    'hourly',
    'unitBased'
];
export const ALLOWED_AUTOMATIC_STATE = [
    'active',
    'paused'
];
export const ALLOWED_COMPLETION_STATE = [
    'completed',
    'notCompleted'
];
export const ALLOWED_AGREEMENT_DISCOUNT_TYPE = [
    'none',
    'value',
    'percent'
];
export const ALLOWED_AGREEMENT_DISCOUNT_EXPIRATION_TYPE = [
    'none',
    'period',
    'date'
];
export const ALLOWED_PRICE_INCREASE_START_ON_TYPE = [
    'yearly',
    'yearlyEffectiveDate'
];
